/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaDesktop, FaMobile, FaPaintBrush, FaUser } from "react-icons/fa";

 

export const servicesData = [
    {
        id: 1,
        title: 'Marketing',
        icon: <BiShoppingBag/>
    },
    {
        id: 2,
        title: 'Content Writing',
        icon: <BiPencil /> 
    },
    {
        id: 3,
        title: 'Web Design',
        icon: <BsCodeSlash />
    },
    {
        id: 4,
        title: 'Video Editing',
        icon: <FaVideo />
    },
    {
        id: 5,
        title: 'Web Development',
        icon: <FaDesktop />
    },
    {
        id: 6,
        title: 'Mobile Development',
        icon: <FaMobile />
    },
    {
        id: 7,
        title: 'UX/UI Design',
        icon: <FaPaintBrush />
    },
    {
        id: 8,
        title: 'Virtual Assistant',
        icon: <FaUser />
    },
]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.